import BreadCrumbs from './BreadCrumbs';

export type { BreadcrumbsItem, BreadcrumbsItems } from './types';
export default BreadCrumbs;
